import { Box, styled } from '@mui/material';

// Tonos SEMÁNTICOS del chip. La bandeja sigue siendo monocroma (superficie, texto y filas
// en grises): lo único que se tiñe es el disco del icono, que es justo lo que deja leer de
// un vistazo si algo fue aprobado, rechazado o está pendiente. Todos salen de tokens que ya
// existen en `palette.js` — cero hex nuevos y ambos modos resueltos.
const toneStyles = (tone, theme) => {
  const { gold, hairline, sessionStatus, surface, text, trend } = theme.palette;

  const tones = {
    // Logros y marca: trofeos, rangos, estrellas.
    gold: { bg: gold.soft, fg: gold.main },
    approved: { bg: sessionStatus.completed.bg, fg: sessionStatus.completed.fg },
    rejected: { bg: sessionStatus.absent.bg, fg: sessionStatus.absent.fg },
    pending: { bg: sessionStatus.pending.bg, fg: sessionStatus.pending.fg },
    // Informativo (sesiones nuevas, noticias, registros): el azul del token de sesiones,
    // que ya es el lenguaje de "agendado" en toda la app.
    info: { bg: sessionStatus.scheduled.bg, fg: sessionStatus.scheduled.fg },
    progress: { bg: sessionStatus.completed.bg, fg: trend.up },
    neutral: { bg: surface.raised, fg: text.secondary }
  };

  const { bg, fg } = tones[tone] || tones.neutral;

  return {
    backgroundColor: bg,
    // El hairline se conserva en el tono neutro; en los teñidos el propio relleno ya da el
    // borde óptico y una línea encima lo ensucia.
    border: tone && tone !== 'neutral' ? '1px solid transparent' : `1px solid ${hairline.main}`,
    color: fg
  };
};

// Chip del icono: disco de 36px con el icono centrado, teñido por `tone` (derivado del tipo
// de notificación en `NotificationRowContent`). Sin `tone` se comporta como siempre.
const StyledNotificationIconChip = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'tone'
})(({ theme, tone }) => ({
  alignItems: 'center',
  borderRadius: '50%',
  display: 'flex',
  flex: 'none',
  height: 36,
  justifyContent: 'center',
  overflow: 'hidden',
  transition: 'background-color 200ms cubic-bezier(0.32, 0.72, 0, 1)',
  width: 36,
  ...toneStyles(tone, theme)
}));

export default StyledNotificationIconChip;
